(function () {
  var selector = '[data-rision-c-specs]';

  function init(root) {
    if (!root || root.getAttribute('data-rision-c-specs-ready') === 'true') return;

    var toggle = root.querySelector('[data-rision-c-specs-toggle]');
    var extras = root.querySelectorAll('[data-rision-c-specs-extra]');
    if (!toggle || !extras.length) return;

    root.setAttribute('data-rision-c-specs-ready', 'true');

    toggle.addEventListener('click', function () {
      var open = root.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function scan(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll(selector);
    Array.prototype.forEach.call(nodes, init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    scan(document);
  }
})();
